import { useMutation } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'
import { getVisitorParkingSettingsQueryKey } from '@/api/visitor-parking/get-visitor-parking-settings'
import { VisitorParkingApiPricingEntry } from '@/models'
import { resetQueries } from '@/utils'

export interface UpdateVisitorParkingSettingsRequest {
  buildingId: number
  pricing: Array<VisitorParkingApiPricingEntry>
}

export interface UpdateVisitorParkingSettingsResponse {
  buildingId: number
  pricing: Array<VisitorParkingApiPricingEntry>
}

export const updateVisitorParkingSettings = async (data: UpdateVisitorParkingSettingsRequest) => {
  const response = await authAPI.put<UpdateVisitorParkingSettingsResponse>(
    `/visitor-parking/settings`,
    data,
  )
  return response.data
}

export const useUpdateVisitorParkingSettings = () => {
  return useMutation({
    mutationFn: updateVisitorParkingSettings,
    onSuccess: (data) => {
      resetQueries(getVisitorParkingSettingsQueryKey({ buildingId: data.buildingId }))
    },
  })
}
